import React from 'react'
import Show from 'services/Show';
import ShowForm from 'components/ShowForm';
import { Spinner } from 'components/atoms';

export default class ShowEdit extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      item: null,
      itemId: match.params.id,
    }
    this.itemClass = Show;
  }

  componentDidMount() {
    this.loadItem();
  }

  itemChanged = (item) => {
    this.setState({ item });
  }

  loadItem = () => {
    this.setState({loading: true});
    this.itemClass.get(this.state.itemId).then((item) => {
      this.setState({ item });
    }).catch(alert).then(() => this.setState({loading: false}) );
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  render() {
    const {item, loading} = this.state;

    return (
      <div className="container">
        <h4>Редактирование выставки</h4>
        {item && <ShowForm item={item} onChange={this.itemChanged} onCancel={this.onCancel} />}
        {loading && <Spinner /> }
      </div>
    );
  }

}